// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__adVny","name":"styles_name__2_-O9","phone":"styles_phone__3fIb1"};